export default {
      id: "college-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#college",
      toString: function () {
        return this.url;
      }
    }